<section class="centered-with-padding pb-7">
  <div class="grid grid-cols-1 gap-y-3 desk:grid-cols-4 desk:gap-5">
    @if (frontsCategories(); as data) {
      @for (frontCategory of data.frontCategories; track $index) {
        <a
          class="h-[276px] w-full"
          [routerLink]="frontCategory.url"
          [queryParams]="{ front_category: frontCategory.name }">
          <app-option-card [image]="frontCategory.image">
            <div card-title-left>{{ frontCategory.name }}</div>
            <div card-title-right>
              <div class="flex gap-x-0.5">
                @for (i of frontCategory.costLevel! | generateRange; track i) {
                  <app-svg [height]="21" [width]="21" src="assets/icons/badge-price.svg" />
                }
              </div>
            </div>
          </app-option-card>
        </a>
      }
    }
  </div>
</section>
